function getLegacyFaqParts(target) {
  if (!(target instanceof Element)) return null;
  const trigger = target.closest('.collapse-item');
  if (!trigger) return null;
  const answer = trigger.nextElementSibling;
  if (!answer?.classList.contains('collapse-value')) return null;
  return { trigger, answer };
}

function updateTrigger(trigger, open) {
  trigger.setAttribute('aria-expanded', String(open));
  trigger.querySelector('i')?.classList.toggle('arz-tw-rotate-45', open);
}

function toggleLegacyFaq(trigger, answer) {
  const open = !answer.classList.contains('collapse-opened');
  answer.classList.toggle('collapse-opened', open);
  updateTrigger(trigger, open);
}

export function initLegacyFaq(root) {
  if (!root || root.dataset.converterFaqReady) return;

  root.querySelectorAll('.collapse-item').forEach((trigger) => {
    const answer = trigger.nextElementSibling;
    if (!answer?.classList.contains('collapse-value')) return;
    const open = answer.classList.contains('collapse-opened');
    trigger.setAttribute('role', 'button');
    trigger.setAttribute('tabindex', '0');
    answer.classList.remove('arz-tw-hidden');
    updateTrigger(trigger, open);
  });

  root.dataset.converterFaqReady = '1';

  root.addEventListener('click', (event) => {
    const parts = getLegacyFaqParts(event.target);
    if (parts) toggleLegacyFaq(parts.trigger, parts.answer);
  });

  root.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    const parts = getLegacyFaqParts(event.target);
    if (!parts) return;
    event.preventDefault();
    toggleLegacyFaq(parts.trigger, parts.answer);
  });
}
